import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Logo } from '.';
import { ThemeSettings } from '../../theme';

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    & img {
        width: 300px;
    }
    min-height: 100vh;
    background: ${ThemeSettings.colors.background};

    & .MuiPaper-root {
      background: transparent;
    }

    & .MuiFormLabel-root {
      color: ${ThemeSettings.colors.text};
    }
`;

export const PublicPageWrapper = (props: { children?: ReactNode }) => {
    return <Wrapper>
        <Logo version={2} />
        {props.children}
    </Wrapper>
}
